/**
 *   Created by ATopcu in 2019
 */
import GroupingResult from 'state/Constants/GroupingResult';
import { splitByCalcType } from 'state/util';
import scope from './scope';
import SelectionState from 'state/selections/SelectionState';
import { selectDefinitions } from 'state/betas/selectors';
import {
  selectGetGroupingParams, selectSideBySideValue, selectScenarioValue
} from 'state/selections/selectors';
import { exchange } from '@ls/js-fetch';
import ScaleType from 'state/Constants/ScaleType';
import { SummaryType } from '@ls/grouping-service';
import GroupingInput from 'state/Constants/GroupingInput';

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const REQUEST_BETA_SBS_DATA = `${scope}/REQUEST_BETA_SBS_DATA`;
export const RECEIVE_BETA_SBS_DATA = `${scope}/RECEIVE_BETA_SBS_DATA`;
export const requestGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    if (!definitions?.length) {
      return;
    }

    const [absDefinitions, bmkDefinitions, relDefinitions] = splitByCalcType(definitions);

    const makeRequest = async (summary, definitions, benchesToo) => {
      dispatch({ type: REQUEST_DATA, summary });
      const bucketBetaTypes = [...new Set(
        definitions
          .filter(({ scaleType }) => scaleType === ScaleType.WeightedAverage)
          .map(({ betaType }) => betaType),
      )];
      const betaTypes = [...new Set(
        definitions
          .filter(({ scaleType }) => scaleType === ScaleType.Contribution)
          .map(({ betaType }) => betaType),
      )];

      const groupingInputs = [];
      const groupingResults = [];
      if (!!definitions.find(def => def.scaleType === ScaleType.WeightedAverage)) {
        groupingInputs.push(GroupingInput.BUCKETS);
        groupingResults.push(GroupingResult.BETA_ATTRIBUTES_BUCKET);
      }
      if (!!definitions.find(def => def.scaleType === ScaleType.Contribution)) {
        groupingResults.push(GroupingResult.BETA_ATTRIBUTES);
      }

      const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);
      const scenarioValue = selectScenarioValue(SelectionState.COMMITTED)(state);
      const sideBySideValue = selectSideBySideValue(SelectionState.COMMITTED)(state)
      let params = getGroupingParams({
        summary,
        benchesToo,
        inputs: groupingInputs,
        results: groupingResults,
        beta_factors: [...new Set(definitions.map(({ betaFactor }) => betaFactor))],
        bucket_beta_types: bucketBetaTypes,
        beta_types: betaTypes,
      });

      dispatch({
        type: RECEIVE_DATA,
        summary,
        data: (await exchange({
          params,
          url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
          cancelId: `data-${scope}-${summary}`,
        }))?.data,
      });

      if (!!scenarioValue && !!sideBySideValue) {
        params = { ...params, workspace: scenarioValue }
        dispatch({ type: REQUEST_BETA_SBS_DATA, summary });
        dispatch({
          type: RECEIVE_BETA_SBS_DATA,
          summary,
          data: (
            await exchange({
              url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
              params,
              cancelId: `data-sbs-${scope}-${summary}`,
            })
          )?.data,
        });
      }
    };


    if (absDefinitions.length || bmkDefinitions.length) {
      makeRequest(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0,
      ).then();
    }

    if (relDefinitions.length) {
      makeRequest(
        SummaryType.RELATIVE,
        relDefinitions,
        true,
      ).then();
    }
  }
};